import $ from 'jquery';

$.jMaskGlobals = {
	maskElements: 'input,td,span,div',
	dataMaskAttr: '*[data-mask]',
	dataMask: true,
	watchInterval: 300,
	watchInputs: true,
	watchDataMask: false,
	byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
	translation: {
		'0': { pattern: /\d/ },
		'9': { pattern: /\d/, optional: true },
		'#': { pattern: /\d/, recursive: true },
		'A': { pattern: /[\dA-Za-z]/ },
		'S': { pattern: /[A-Za-z]/ },
		'C': { pattern: /[A-Za-z]/, recursive: true },
		'O': { pattern: /[A-Za-z]/, optional: true },
		'+': { pattern: /\+/, optional: true },
		'.': { pattern: /\./, optional: true },
		'-': { pattern: /-/, optional: true },
	},
};
